import { render, staticRenderFns } from "./BulkUpload.vue?vue&type=template&id=40cbe09b&scoped=true"
import script from "./BulkUpload.vue?vue&type=script&lang=js"
export * from "./BulkUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cbe09b",
  null
  
)

export default component.exports